import axios from 'axios';
import { ICognitoAuthUser } from './types';
import { getEnv } from '../texts';
const storageType = localStorage || window.localStorage;

export function SetSessionStorage(key: string, value: string) {
  sessionStorage.setItem(key, value);
}

export function GetSessionStorage(key: string) {
  return sessionStorage.getItem(key);
}

export function SetStorageComponent(key: string, value: string) {
  storageType.setItem(key, value);
}

export function GetStorageComponent(key: string) {
  return storageType.getItem(key);
}

export function DeleteStorageComponent(key: string) {
  return storageType.removeItem(key);
}

export function SetJsonStorageComponent(key: string, value: string) {
  storageType.setItem(key, JSON.stringify(value));
}

export function clearStorageComponent() {
  storageType.clear();
}

export function getUserStorageComponent(key: string) {
  const userInfo = storageType.getItem(key);
  if (userInfo !== null) {
    const item = JSON.parse(userInfo);
    return item;
  }
  return null;
}

export function setCognitoSession(cognitoSession: ICognitoAuthUser) {
  const { signInUserSession } = cognitoSession;
  const { idToken, accessToken } = signInUserSession;
  const { payload } = idToken;
  localStorage.setItem('access_token', accessToken.jwtToken);
  localStorage.setItem('id_token', idToken.jwtToken);
  localStorage.setItem('expires_at', `${payload.exp}`);
}

export function removeCognitoSession() {
  localStorage.removeItem('access_token');
  localStorage.removeItem('id_token');
  localStorage.removeItem('expires_at');
  localStorage.removeItem('userinfo');
  localStorage.removeItem('employeesFilter');
  localStorage.removeItem('ecmaFilter');
  localStorage.removeItem('clientEmployeeListFilter');
  localStorage.removeItem('assessmentListFilter');
  localStorage.removeItem('reopenAssessmentFilter');
  localStorage.removeItem('techViewSquadList');
  localStorage.removeItem('quickFilter');
  localStorage.removeItem('userPermissions');
  localStorage.removeItem('assignedTeamFilter');
  localStorage.removeItem('requiredResourceFilter');
  localStorage.removeItem('invoiceDateFilter');
  localStorage.removeItem('permissionGroupFilter');
  localStorage.removeItem('personaFilter');
}

export function removeCookies() {
  const cookies = document.cookie.split(';');
  for (let i = 0; i < cookies.length; i++) {
    const cookie = cookies[i];
    const eqPos = cookie.indexOf('=');
    const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
    document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:00 GMT';
  }
}

export function clearAllStorage() {
  localStorage.clear();
  sessionStorage.clear();
  removeCookies();
}

interface QueryString<QValue> {
  [key: string]: QValue;
}

export const getQueryStringParams = (query: string): QueryString<string> => {
  return query
    ? (/^[?#]/.test(query) ? query.slice(1) : query).split('&').reduce((params: any, param) => {
        const [key, value] = param.split('=');
        try {
          const tempValue = value ? decodeURIComponent(value.replace(/\+/g, ' ')) : '';
          // for array query params
          if (tempValue.split(',').length > 1) {
            params[key] = tempValue.split(',');
          } else {
            params[key] = tempValue;
          }
          return params;
        } catch (error) {
          // URIError: URI malformed for query param like ?keyword=%&
          params[key] = value;
          return params;
        }
      }, {})
    : {};
};

export const jsonServer = axios.create({ baseURL: getEnv('VITE_JSON_SERVER_BASE_URL') });
